import React from "react";
import Home from "./Home";
import PageComponent from "../PageComponent";
import { labels } from "../../../../localization/labels";

class HomeContainer extends PageComponent {

  getComponentTitle = () => {
    return labels.home;
  };

  render() {
    return <Home />;
  }
}

export default HomeContainer;
